// src/App.vue

<template>
  <v-app>
    <MenuComponent />
    <v-main>
      <v-container>
        <router-view></router-view> <!-- Router view to display routed components -->
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import MenuComponent from './components/MenuComponent.vue';
import { eventService } from './services/EventService'

export default {
  name: 'App',

  components: {
    MenuComponent,
  },
  
  created() {
    // Check if user is logged in and redirect if not
    if (!this.$store.getters.isUserLoggedIn) {
      this.$router.push({ name: 'LoginPage' });
    }
  },

  beforeUnmount() {  // Use beforeDestroy instead of onBeforeUnmount
    eventService.disconnectAll();
  }

};
</script>

<style>
/* Add any custom styles here */
</style>

